export const RUBRIC_ITEM = 'item'
export const RUBRIC_LIST = 'list'
